<h1>My Account</h1>
<app-dynamic-content blocktitle="My Account Intro - {{lmsUserService.User.GetMemberTypes('ABMP').shift()}}">
</app-dynamic-content>

<p>If you're looking for an invoice that isn't shown below, please <a [routerLink]="null"
    (click)="RefreshInvoices()">refresh your order history</a>.</p>
<ng-container *ngIf="(invoiceService.Loaded$ | async) as loaded; else loadingInvoices">
  <ng-container *ngIf="(Invoices$ | async) as invoices; else loadingInvoices">
    <ng-container *ngIf="CEInvoices; else noInvoices">
      <section *ngFor="let invoice of invoices;  let i = index " class="mb-3">
        <div class="card">
          <div class="card-header row justify-content-between navy" (click)="toggleShowDiv(i)">
            <strong>
              <fa-icon *ngIf="this.activeInvoice!==i" icon="chevron-right" size="md" (click)="toggleShowDiv(i)">
              </fa-icon>
              <fa-icon *ngIf="this.activeInvoice==i" icon="chevron-down" size="md" (click)="toggleShowDiv(i)">
              </fa-icon>
              Invoice: {{invoice.inv_code}}
            </strong>
            <span>{{invoice.inv_trx_date | date:'mediumDate' }}</span>
            <span><strong>Total</strong>: ${{invoice.inv_total | number:'1.2-2'}}</span>
          </div>
          <div class="card-body pt-1 {{this.activeInvoice==i ? 'active, strong' : 'none'}}" id="{{i}}"
            [@slideInOut]="this.activeInvoice==i ? 'in': 'out'">
            <aside *ngFor="let detail of invoice.InvoiceDetails" class="mb-1">
              <div class="row justify-content-between pb-1">
                <span>
                  <fa-icon icon="check" size="sm" class="green mr-3"></fa-icon>
                  <a *ngIf="detail.CEItem"
                    routerLink="../{{detail.ptp_code == 'Course Fee' ? 'course' : 'package'}}/{{detail.CEItem.alias}}">{{detail.prc_display_name}}</a>
                  <span *ngIf="!detail.CEItem">{{detail.prc_display_name}}</span>
                </span>
                <span>${{detail.ivd_price | number:'1.2-2'}}</span>
              </div>
            </aside>
            <aside *ngFor="let detail of invoice.AdditionalInvoiceDetails" class="mt-1 ghostwhite">
              <div class="row justify-content-between pb-1">
                <span>
                  <fa-icon icon="minus" size="sm" class="blue mr-3"></fa-icon>
                  <span>{{detail.prc_display_name}}</span>
                </span>
                <span>-${{detail.ivd_price | number:'1.2-2'}}</span>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loadingInvoices>
  <p>
    <app-load-indicator description="load your order history. This may take some time based on your order volume.">
    </app-load-indicator>
  </p>
</ng-template>

<ng-template #noInvoices>
  <p>We didn't find any CE course purchases on your account.</p>
</ng-template>
